<style scoped lang="less">
/deep/ .el-popover {
	z-index: 10002 !important;
}

.choiostitle {
	display: flex;
	padding: 0.8rem 0.4rem;
	align-items: center;
	justify-content: space-between;
	background-color: #fff;
	margin-bottom: 1rem;

	.choiosvspde {
		/deep/ .el-button-group {
			width: 9rem;

			button:first-child {
				width: 7rem;
				height: 2rem;
				padding: 0 3px;
			}

			button:last-child {
				width: 1.6rem;
				height: 2rem;
				position: relative;
				padding: 0;
				top: 0px;
				left: 0px;
			}
		}
	}

	.choiostitleleft {
		padding: 0.4rem 1.4rem;
		font-size: 0.8rem;
		border-radius: 5px;
		color: #fff;
		background-color: #07b446;
		border: 1px solid;
		text-align: left;
		margin-left: 0.6rem;

		span {
			font-weight: 900;
		}
	}

	.choiosvdate {
		width: 9rem;
		margin-right: 2%;

		/deep/ .el-input {
			width: 100%;
		}
	}

	.choiosipt {
		// width: 9rem;
		margin-right: 2%;

		/deep/ .el-input {
			width: 100%;
		}
	}

	.choiostitleright {
		display: flex;
		align-items: center;
		justify-content: flex-end;

		div {
			margin: 0 0.2rem;
		}

		.choiosipt {
			/deep/ .el-input--prefix .el-input__inner {
				height: 2rem;
				padding: 1rem 2rem;
			}

			/deep/ .el-input__prefix {
				top: -3px;
			}

			/deep/ .el-input__suffix {
				top: -3px;
			}
		}
	}
}

.orderstable {
	// margin-top: 1rem;
	padding: 1rem;
	width: 100%;
	background-color: #fff;
	border-top: 4px solid #22af47;
	border-radius: 2px;

	.oderlookds {
		background-color: #f41127;
	}

	.oderlookd {
		padding: 0.1rem;
		width: 4rem;
		background: rgb(78, 192, 204);
		color: rgb(255, 255, 255);
		margin: 0 auto;
		border-radius: 5px;
	}

	.tabslis {
		/deep/ & ::-webkit-scrollbar {
			width: 5px;
			height: 8px;
			background: linear-gradient(to right, #2e61bf, #60c363);
		}

		& ::-webkit-scrollbar {
			width: 10px;
			height: 5px;
			// background: red;
		}

		& ::-webkit-scrollbar-track {
			-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
			border-radius: 0;
			background: rgba(0, 0, 0, 0.1);
		}

		/deep/ .el-table {
			th,
			td {
				text-align: center;
			}

			td {
				button {
					color: #fff;
					border-radius: 5px;
				}

				.looking {
					background: #0d6efd;
					margin-left: 10px;

					span {
						font-size: 0.6rem;
						font-weight: 800;
					}
				}

				.looking:hover {
					background: #0b67e6;
				}

				// .giveempower {
				// 	background: #FF8300;

				// 	span {
				// 		font-size: 0.6rem;
				// 	}
				// }

				.edit {
					background: #17a001;

					span {
						font-size: 0.6rem;
					}
				}

				.edit:hover {
					background: #1fcf00;
				}

				.delete {
					background: #ec0f25;

					span {
						font-size: 0.6rem;
					}
				}

				.delete:hover {
					background: #ff1128;
				}
			}
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}

		/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
			background: linear-gradient(to right, #018761, #39b170);
			// color: #FFF;
		}
	}

	.schooltitle {
		font-size: 1.2rem;
		color: #22af47;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #ccc;
		padding-bottom: 1rem;
		position: relative;

		button {
			padding: 0.4rem;
			background: #fe8930;
			font-size: 0.6rem;
			border-radius: 3px;
			padding: 0.6rem 1.2rem;
			position: absolute;
			right: 1%;
			color: #fff;

			span {
				color: #fff;
				margin-right: 0.2rem;
				font-weight: 900;
			}
		}

		span.el-icon-s-management {
			display: block;
			padding: 0.4rem;
			border-radius: 50%;
			font-size: 1rem;
			margin-right: 0.4rem;
			box-sizing: border-box;
			background: #22af47;
			color: #fff;
		}
	}
}

.paginations {
	height: 3rem;
	line-height: 3rem;

	input {
		width: 3rem;
		height: 1.8rem;
		padding: 0 0 0 0.8rem;
		border: 1px solid #ccc;
	}
}

/deep/ .el-dialog {
	.el-dialog__header {
		background: #40a9ff;
		color: #fff;
	}

	.el-dialog__title {
		color: #fff;
	}

	.el-dialog__headerbtn .el-dialog__close {
		color: #fff;
	}
}

/deep/ .tablestitle {
	color: #333;

	.cell {
		font-weight: 600 !important;
	}

	// font-size: 1rem;
}
</style>
<template>
	<div>
		<titles titlename="我的预约" titlecontent="这里可以看到我的预约一些信息" :mbx="paths"></titles>
		<el-dialog :show-close="false" :title="titlesa" :append-to-body="true" center :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
			<div class="students">
				<el-descriptions title="学员信息">
					<el-descriptions-item label="姓名">{{ userobjs.ui_realName }}</el-descriptions-item>
					<el-descriptions-item label="学号">{{ userobjs.ui_joyNumber }}</el-descriptions-item>
					<el-descriptions-item label="班级">{{ userobjs.cla_name }}</el-descriptions-item>
					<el-descriptions-item label="所属专业" span="3">{{ userobjs.pro_name }} 1188 号</el-descriptions-item>
					<el-descriptions-item label="联系电话" span="1">{{ userobjs.ui_mobile }}</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="预约信息">
					<el-descriptions-item :label="sletejg == 1 ? '预约设备' : '预约实训室'">{{ sletejg == 1 ? appoint.te_deviceName : lookingsobj.tr_name }}</el-descriptions-item>
					<el-descriptions-item label="设备地址" span="3" v-if="sletejg == 1">{{ appoint.tr_address }}</el-descriptions-item>
					<el-descriptions-item label="预约人数" span="3">{{ appoint.ap_reservedNum }}人</el-descriptions-item>
					<el-descriptions-item label="预约时间段" span="3">{{ appoint.ap_appDate }} {{ appoint.ap_startTime }}~{{ appoint.ap_endTime }}</el-descriptions-item>
					<el-descriptions-item label="预约申请信息" span="1">{{ appoint.ap_appContent }}</el-descriptions-item>
				</el-descriptions>

				<el-descriptions title="审核信息">
					<el-descriptions-item label="审核人" span="3">{{ appoint.ap_auditName }}</el-descriptions-item>
					<el-descriptions-item label="审核状态" span="3">{{ appoint.ap_auditState }}</el-descriptions-item>
					<el-descriptions-item label="审核时间" span="3">{{ appoint.at_auditTime }}</el-descriptions-item>
				</el-descriptions>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
		<div class="choios">
			<div class="choiostitle">
				<div>
					<button class="choiostitleleft" @click="gomypromise('实训设备')">
						<span class="el-icon-wallet"></span>
						我要预约实训设备
					</button>
					<button class="choiostitleleft" style="background-color: #00aaff;" @click="gomypromise('实训室')">
						<span class="el-icon-menu"></span>
						我要预约实训室
					</button>
				</div>

				<div class="choiostitleright col-xs-8 col-sm-8 col-md-8 col-lg-8">
					<div class="choiosipt col-xs-4 col-sm-4 col-md-4 col-lg-4">
						<el-input @blur="changetrainlist()" placeholder="搜索" prefix-icon="el-icon-search" v-model="search"></el-input>
					</div>
					<!-- <div class="choiosvdate choiosipt">
						<el-date-picker v-model="vdate" type="date" placeholder="选择日期">
						</el-date-picker>
					</div>-->
					<div class="choiosvspde choiosipt">
						<el-dropdown split-button trigger="click" @command="handleCommand">
							{{ trainname }}
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :command="sletejg == '1' ? '所有实训设备' : '所有实训室'">{{ sletejg == '1' ? '所有实训设备' : '所有实训室' }}</el-dropdown-item>
								<el-dropdown-item v-for="(item, index) in trinaslist" :key="index" :command="sletejg == '1' ? item.te_deviceName : item.tr_name">
									{{ sletejg == '1' ? item.te_deviceName : item.tr_name }}
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
			</div>
			<el-tabs type="border-card" v-model="sletejg" @tab-click="handleClick">
				<el-tab-pane label="我的设备预约记录" name="1">
					<div class="orderstable">
						<p class="schooltitle">
							<span class="el-icon-s-management"></span>
							<span>我的设备预约记录</span>
						</p>
						<div class="paginations">
							每页显示
							<input type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="tabsnun" @change="changenumber()" />
							行
						</div>
						<div class="tabslis">
							<template>
								<el-table :data="tableData" header-row-class-name="tablestitle" border style="width: 100%">
									<el-table-column fixed prop="tr_name" label="实训室名称">
										<template slot-scope="scope">
											<p>{{ scope.row.tr_name }}</p>
										</template>
									</el-table-column>
									<el-table-column prop="te_deviceName" label="设备名称"></el-table-column>
									<el-table-column prop="ap_appContent" label="预约说明">
										<template slot-scope="scope">
											<p :style="{ color: scope.row.ap_appContent == '' ? 'red' : '' }">
												{{ scope.row.ap_appContent == '' ? '暂无说明' : scope.row.ap_appContent }}
											</p>
										</template>
									</el-table-column>
									<el-table-column prop="ap_reservedNum" label="预约人数" width="80"></el-table-column>
									<el-table-column prop="ap_createTime" label="预约创建日期"></el-table-column>
									<el-table-column prop="ordertime" label="预约时间段">
										<template slot-scope="scope">
											<p>{{ scope.row.ap_startTime }} ~ {{ scope.row.ap_endTime }}</p>
										</template>
									</el-table-column>
									<el-table-column prop="zt" label="状态">
										<template slot-scope="scope">
											<p
												style="font-size: 0.8rem;border: 1px solid;width: 60%;margin: 0 auto;border-radius: 13px;color: #fff;background: #d63d5e;"
												v-if="scope.row.ap_auditState == '已取消'"
											>
												{{ scope.row.ap_auditState }}
											</p>
											<p
												style="font-size: 0.8rem;border: 1px solid;width: 60%;margin: 0 auto;border-radius: 13px;color: #fff;background: #15BE85;"
												v-if="scope.row.ap_auditState == '已审核'"
											>
												{{ scope.row.ap_auditState }}
											</p>
											<p
												style="font-size: 0.8rem;border: 1px solid;width: 60%;margin: 0 auto;border-radius: 13px;color: #fff;background: #FF9528;"
												v-if="scope.row.ap_auditState == '已驳回'"
											>
												{{ scope.row.ap_auditState }}
											</p>
											<p
												style="font-size: 0.8rem;border: 1px solid;width: 60%;margin: 0 auto;border-radius: 13px;color: #fff;background: #FF9528;"
												v-if="scope.row.ap_auditState == '待审核'"
											>
												{{ scope.row.ap_auditState }}
											</p>
											<p
												style="font-size: 0.8rem; border: 1px solid;width: 60%;margin: 0 auto;border-radius: 13px;color: #fff;background: #15BE85;"
												v-if="scope.row.ap_auditState == '审核通过'"
											>
												{{ scope.row.ap_auditState }}
											</p>
										</template>
									</el-table-column>
									<el-table-column fixed="right" label="操作">
										<template slot-scope="scope">
											<div class="userusec d-sm-none d-md-block">
												<el-tooltip class="item" effect="dark" content="查看记录" placement="top-start">
													<el-button size="small" :class="'looking'" @click="lookings(scope.row)">
														<span class="el-icon-view" style="color: #fff;"></span>
													</el-button>
												</el-tooltip>

												<el-tooltip class="item" effect="dark" content="取消预约" placement="left-start">
													<el-popconfirm
														confirm-button-text="确定"
														cancel-button-text="突然反悔了"
														title="你确定要取消预约吗？"
														@confirm="tabledeletes($event, scope.row.sx_ap_guid)"
													>
														<el-button
															size="small"
															class="delete"
															:slot="
																scope.row.ap_auditState == '待审核' || scope.row.ap_auditState == '已审核' || scope.row.ap_auditState == '审核通过'
																	? 'reference'
																	: ''
															"
														>
															<span class="el-icon-delete" style="color: #fff;"></span>
														</el-button>
													</el-popconfirm>
												</el-tooltip>
											</div>
											<div class="userusec d-sm-block d-md-none">
												<el-dropdown trigger="click">
													<p class="el-dropdown-link">···</p>
													<el-dropdown-menu slot="dropdown">
														<el-tooltip class="item" effect="dark" content="查看记录" placement="top-start">
															<el-button size="small" :class="'looking'" @click="lookings(scope.row)">
																<span class="el-icon-view" style="color: #fff;"></span>
															</el-button>
														</el-tooltip>

														<el-tooltip class="item" effect="dark" content="取消预约" placement="left-start">
															<template>
																<el-popconfirm
																	confirm-button-text="确定"
																	cancel-button-text="突然反悔了"
																	title="你确定要取消预约吗？"
																	@confirm="tabledeletes($event, scope.row.sx_ap_guid)"
																>
																	<el-button
																		size="small"
																		class="delete"
																		:slot="
																			scope.row.ap_auditState == '待审核' ||
																			scope.row.ap_auditState == '已审核' ||
																			scope.row.ap_auditState == '审核通过'
																				? 'reference'
																				: ''
																		"
																	>
																		<span class="el-icon-delete" style="color: #fff;"></span>
																	</el-button>
																</el-popconfirm>
															</template>
														</el-tooltip>
													</el-dropdown-menu>
												</el-dropdown>
											</div>
										</template>
									</el-table-column>
								</el-table>
							</template>
						</div>

						<div class="tabsnum">
							<p>
								显示
								<span>1</span>
								到
								<span>{{ tabsnun }}</span>
								,共
								<span>{{ alltanum }}</span>
								条记录
							</p>
							<div class="elpagian" v-if="tableData.length > 0">
								<el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" :page-size="tabsnum" :total="alltanum"></el-pagination>
							</div>
						</div>
					</div>
				</el-tab-pane>

				<el-tab-pane label="我的实训室预约记录" name="2">
					<div class="orderstable">
						<p class="schooltitle">
							<span class="el-icon-s-management"></span>
							<span>我的实训室预约记录</span>
						</p>
						<div class="paginations">
							每页显示
							<input type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="tabsnun" @change="changenumber()" />
							行
						</div>
						<div class="tabslis">
							<template>
								<el-table :data="tableData" header-row-class-name="tablestitle" border style="width: 100%">
									<el-table-column fixed prop="tr_name" label="实训室名称"></el-table-column>
									<!-- <el-table-column prop="te_deviceName" label="设备名称">
									</el-table-column> -->
									<el-table-column prop="ap_appContent" label="预约说明">
										<template slot-scope="scope">
											<p :style="{ color: scope.row.ap_appContent == '' ? 'red' : '' }">
												{{ scope.row.ap_appContent == '' ? '暂无说明' : scope.row.ap_appContent }}
											</p>
										</template>
									</el-table-column>
									<el-table-column prop="ap_reservedNum" label="预约人数" width="80"></el-table-column>
									<el-table-column prop="ap_createTime" label="预约创建日期"></el-table-column>
									<el-table-column prop="ordertime" label="预约时间段">
										<template slot-scope="scope">
											<p>{{ scope.row.ap_startTime }} ~ {{ scope.row.ap_endTime }}</p>
										</template>
									</el-table-column>
									<el-table-column prop="zt" label="状态">
										<template slot-scope="scope">
											<p
												style="font-size: 0.8rem;border: 1px solid;width: 60%;margin: 0 auto;border-radius: 13px;color: #fff;background: #d63d5e;"
												v-if="scope.row.ap_auditState == '已取消'"
											>
												{{ scope.row.ap_auditState }}
											</p>
											<p
												style="font-size: 0.8rem;border: 1px solid;width: 60%;margin: 0 auto;border-radius: 13px;color: #fff;background: #15BE85;"
												v-if="scope.row.ap_auditState == '已审核'"
											>
												{{ scope.row.ap_auditState }}
											</p>
											<p
												style="font-size: 0.8rem;border: 1px solid;width: 60%;margin: 0 auto;border-radius: 13px;color: #fff;background: #FF9528;"
												v-if="scope.row.ap_auditState == '已驳回'"
											>
												{{ scope.row.ap_auditState }}
											</p>
											<p
												style="font-size: 0.8rem;border: 1px solid;width: 60%;margin: 0 auto;border-radius: 13px;color: #fff;background: #FF9528;"
												v-if="scope.row.ap_auditState == '待审核'"
											>
												{{ scope.row.ap_auditState }}
											</p>
											<p
												style="font-size: 0.8rem; border: 1px solid;width: 60%;margin: 0 auto;border-radius: 13px;color: #fff;background: #15BE85;"
												v-if="scope.row.ap_auditState == '审核通过'"
											>
												{{ scope.row.ap_auditState }}
											</p>
										</template>
									</el-table-column>
									<el-table-column fixed="right" label="操作">
										<template slot-scope="scope">
											<div class="userusec d-sm-none d-md-block">
												<el-tooltip class="item" effect="dark" content="查看记录" placement="top-start">
													<el-button size="small" :class="'looking'" @click="lookings(scope.row)">
														<span class="el-icon-view" style="color: #fff;"></span>
													</el-button>
												</el-tooltip>

												<el-tooltip class="item" effect="dark" content="取消预约" placement="left-start">
													<template>
														<template>
															<el-popconfirm
																confirm-button-text="确定"
																cancel-button-text="突然反悔了"
																title="你确定要取消预约吗？"
																@confirm="tabledeletes($event, scope.row.sx_ap_guid)"
															>
																<el-button
																	size="small"
																	class="delete"
																	:slot="
																		scope.row.ap_auditState == '待审核' ||
																		scope.row.ap_auditState == '已审核' ||
																		scope.row.ap_auditState == '审核通过'
																			? 'reference'
																			: ''
																	"
																>
																	<span class="el-icon-delete" style="color: #fff;"></span>
																</el-button>
															</el-popconfirm>
														</template>
													</template>
												</el-tooltip>
											</div>
											<div class="userusec d-sm-block d-md-none">
												<el-dropdown trigger="click">
													<p class="el-dropdown-link">···</p>
													<el-dropdown-menu slot="dropdown">
														<el-tooltip class="item" effect="dark" content="查看记录" placement="top-start">
															<el-button size="small" :class="'looking'" @click="lookings(scope.row)">
																<span class="el-icon-view" style="color: #fff;"></span>
															</el-button>
														</el-tooltip>

														<el-tooltip class="item" effect="dark" content="取消预约" placement="left-start">
															<template>
																<el-popconfirm
																	confirm-button-text="确定"
																	cancel-button-text="突然反悔了"
																	title="你确定要取消预约吗？"
																	@confirm="tabledeletes($event, scope.row.sx_ap_guid)"
																>
																	<el-button
																		size="small"
																		class="delete"
																		:slot="
																			scope.row.ap_auditState == '待审核' ||
																			scope.row.ap_auditState == '已审核' ||
																			scope.row.ap_auditState == '审核通过'
																				? 'reference'
																				: ''
																		"
																	>
																		<span class="el-icon-delete" style="color: #fff;"></span>
																	</el-button>
																</el-popconfirm>
															</template>
														</el-tooltip>
													</el-dropdown-menu>
												</el-dropdown>
											</div>
										</template>
									</el-table-column>
								</el-table>
							</template>
						</div>

						<div class="tabsnum">
							<p>
								显示
								<span>1</span>
								到
								<span>{{ tabsnun }}</span>
								,共
								<span>{{ alltanum }}</span>
								条记录
							</p>
							<div class="elpagian" v-if="tableData.length > 0">
								<el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" :page-size="tabsnum" :total="alltanum"></el-pagination>
							</div>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import { getMyAppointmentList, cancelAppointment, getTrainEquipmentList, getAppointmentSingle, GetsxMyAppointmentList } from '@/request/api/userapi/studenthome.js';
import AppOptions from '@/config/AppOptions.vue';
import { getbfyGetTrainList } from '@/request/api/trainroom/trainroom.js';

export default {
	data() {
		return {
			// 对话框
			dialogVisible: false,
			titlesa: '取消',
			tabsnun: 10,
			alltanum: 0,
			// 搜索
			search: '',
			// 时间选择
			vdate: '',
			// 标题
			paths: [
				{
					path: '/usercenter/myuserpromise',
					name: '我的预约'
				}
			],
			pageindex: 1,
			tableData: [],
			// 实训室列表不分页
			trinaslist: [],
			trainname: '所有实训设备',
			// 查看详细信息
			lookingsobj: {},
			// 学员信息
			userobjs: {},
			appoint: {},
			sletejg: '1'
		};
	},
	mounted() {
		this.getmyappoint();
	},
	components: {
		titles
	},
	computed: {
		tabsnum() {
			return Number(this.tabsnun);
		}
	},
	created() {
			AppOptions.appEmpty = false;
		},
	methods: {
		gomypromise(roomname) {
			this.$router.push('/usercenter/mypromise?roomname=' + roomname);
		},

		// 查看详细信息
		lookings(tobj) {
			this.dialogVisible = true;
			this.lookingsobj = tobj;
			// console.log(this.lookingsobj)
			this.titlesa = '您的预约申请' + tobj.ap_auditState;
			getAppointmentSingle(tobj.sx_ap_guid).then(res => {
				console.log(res);
				this.userobjs = res.data.data.user;
				this.appoint = res.data.data.appoint;
			});
		},

		// 下拉边框
		handleCommand(command) {
			// this.$message(command);
			this.trainname = command;
			if (command == '所有实训设备' || command == '所有实训室') {
				this.search = '';
				this.getmyappoint();
			} else {
				this.search = command;
				this.getmyappoint();
			}
		},

		// 取消预约
		tabledeletes(e, id) {
			cancelAppointment(id).then(res => {
				// console.log(res)
				if (res.data.code == 1) {
					this.$message({
						message: '恭喜你，' + res.data.msg,
						type: 'success'
					});
					this.getmyappoint();
				} else {
					this.$message({
						message: res.data.msg,
						type: 'error'
					});
				}
			});
		},

		// 搜索
		changetrainlist() {
			this.getmyappoint();
		},

		// 改变值
		changenumber() {
			this.tabsnun = Number(this.tabsnun);
			this.getmyappoint();
		},

		// 改变
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.pageindex = val;
			this.getmyappoint();
		},

		handleClick() {
			// alert('button click');
			if (this.sletejg == 1) {
				this.trainname = '所有实训设备';
			} else {
				this.trainname = '所有实训室';
			}

			this.getmyappoint();
		},
		handleClose(done) {
			// this.$confirm('确认关闭？')
			// 	.then(_ => {
			// 		done();
			// 	})
			// 	.catch(_ => {});
		},

		getmyappoint() {
			var id = localStorage.getItem('siguid');

			if (this.sletejg === '1') {
				let myappont = {
					ap_applicantGuid: localStorage.getItem('uiguid'),
					pageIndex: this.pageindex,
					pageSize: this.tabsnun,
					te_deviceName: this.search + ''
				};
				getTrainEquipmentList(id).then(res => {
					// console.log(res, "实训设备")
					this.trinaslist = res.data.data;
				});
				getMyAppointmentList(myappont).then(res => {
					console.log(res.data.data, '预约列表');
					if (res.data.data && res.data.data.list.length > 0) {
						this.alltanum = res.data.data.totalCount;
						this.tableData = res.data.data.list;
					} else {
						this.tableData = [];
						this.alltanum = 0;
					}
				});
			} else {
				let myappont = {
					ap_applicantGuid: localStorage.getItem('uiguid'),
					pageIndex: this.pageindex,
					pageSize: this.tabsnun,
					te_deviceName: this.search + ''
				};

				getbfyGetTrainList(id).then(res => {
					// console.log(res, "实训室")
					this.trinaslist = res.data.data;
				});

				GetsxMyAppointmentList(myappont).then(res => {
					// console.log(res.data.data, "预约列表")
					if (res.data.data && res.data.data.list.length > 0) {
						this.alltanum = res.data.data.totalCount;
						this.tableData = res.data.data.list;
					} else {
						this.tableData = [];
						this.alltanum = 0;
					}
				});
			}
		}
	}
};
</script>
